// import React,{useEffect,useState} from 'react';
//Added Nitesh on 12 09 2026
import React,{useEffect,useState,useRef} from 'react';
//Ended Nitesh on 12 09 2026
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import '../assets/css/style.css';
import '../assets/css/AdminDashboard.css';
import Nav from '../Nav';
import APP from '../App';
import avtlogo from "../img/avt.png";
import avtprofile from "../img/avatar.jpg";
// import { getUser, removeUserSession,getUserRole,getLoginName,getUserId ,auTHURL,aPIURL,profileImageUrl} from '../utils/common';
//Added Nitesh on 12 09 2026
import {getUser,removeUserSession,getUserRole, getLoginName, getUserId, auTHURL, aPIURL, profileImageUrl, profileDocSize, profileDocTypes} from '../utils/common';
//Ended NItesh on 12 09 2026
import Modal from '../components/LoginModal';
import Modalxl from '../components/Modalxl';
import ModalAlert from "../components/Modal";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate  } from "react-router-dom";
import $ from 'jquery'; 


const handleLogout = () => {
  removeUserSession();
  //const root = ReactDOM.createRoot(document.getElementById('root'));
  //root.render(<Login/>);    
  window.location.href = "/";
  }
  

const AdminMaster = () => {
   const history = useNavigate();
    const userName = getUser();
    const auTH_URL=auTHURL();
    const API_URL=aPIURL();
     const Profile_Image_URL=profileImageUrl();
    const AUTH_URL= auTHURL();
    const [inputs, setInputs] = useState({});
    const user_name = getUser();
    const user_role = getUserRole();
    const user_id = getUserId();
    const login_name = getLoginName();
    const [showCPModal,setShowCPModal]=useState(false);
    const [showUpdateDetails, setShowUpdateDetails]= useState(false);
    
    const [cDisplay, setCDisplay]= useState('none');
    const [stateId, setStateId]= useState( '');
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData]= useState([]);
    const [countryId, setCountryId]= useState('');   
    const [cNameLevel, setCNameLevel]= useState('Name'); 
    const [custType ,setCustType] = useState(1);
    const [redioDispl, setRedioDispl]= useState(false);
    const [changePass, setChangePass]= useState(false);
    const [actionId , setActionId]= useState('1');
    const [custID, setCustID] = useState('0');
    const [custGST ,setCustGST]= useState("");  
    const [menuDisplay, setMenuDisplay]= useState('none'); 
    const [alertTotal, setAlertTotal] = useState(0);
    const [showAlerts,setShowAlerts]=useState(false);
    const [vAlert, setVAlert] = useState([]);
    const [alertCount, setAlertCount] = useState(false);
    const [quickMenuDisplay,setQuickMenuDisplay]  = useState('none');
    let [profileImage,setProfileImage] = useState("img/avatar.jpg");
    let [newImageName,setNewImageName]=useState('');
    let [newImageExt,setNewImageExt]=useState("null");

    //Added Nitesh on 12 09 2026
    // Document States
const [documents, setDocuments] = useState([]);
const [documentType, setDocumentType] = useState('');
const [documentFile, setDocumentFile] = useState(null);
const fileInputRef = useRef(null);
    //Ended Nitesh on 12 09 2026

   useEffect(() => 
   {

    document.body.classList.add("home-page");
    //alert(user_role);
    if(user_role== "Customer")
        {
           
            setMenuDisplay('block');
            CountAlert();
            setQuickMenuDisplay('block');
            ShowProfilePic(user_id);
            
        }
        else
        {
          setMenuDisplay('none');
          setQuickMenuDisplay('none');

        }
  }, []);
 //timer 15 second will update Summary count
 useEffect(() => {
  let interval = setInterval(() => 
  {    
    CountAlert();   
    //showVehicleAlert(1);    
    
  }, 10000);

  return () => clearInterval(interval);
}, []);

  const closeModal = () => {
    
    setShowAlerts(false);
    GoToPage("/Alert");

  }
  const GoToPage = (e) => 
    {
      history(e); // Dynamic call pages
    
    };
 //Profile Pic Code starts
    const ShowProfilePic=(C_Id)=>
    {
        const urls=API_URL+`GetGPSCustomerDetails/${C_Id}/`;
       
        axios.post(urls).then(response => 
        {          
             setProfileImage(Profile_Image_URL+response.data.data[0].profileImgFileName);                                                       
        }
        ).catch(function (error) 
        {
             console.log(error.message);          
        });   
    }
    const reader = new FileReader();
     const readFile = (file) => {
      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    };

     const getAsByteArray = async (file) => 
      {
        const buffer = await readFile(file);
        const uint8Array = new Uint8Array(buffer);

        return btoa(String.fromCharCode(uint8Array));
        
    };

        let base64String = "";
        const imageUploaded=()=>
        {
            let file = document.querySelector('input[type=file]')['files'][0];
            const objectURL = URL.createObjectURL(file);
            let imgType = file.type.replace('image/','.');    
           
            if((file.size/1024)<201)    
            {
             
                setNewImageExt(imgType);	 
                setProfileImage(objectURL);
                let reader = new FileReader();            
                reader.onload = function () 
                {
                    base64String = reader.result.replace("data:", "")
                    .replace(/^.+,/, "");
                    setNewImageName(base64String);
                    console.log(base64String);
                }
                    reader.readAsDataURL(file);
            }  
            else
            {
                    toast.error("Profile Image Maximum Size is 200KB.");
                    console.log("Profile Image Maximum Size is 200KB.");  
            }
        }

        //Added Nitesh On 12 09 2026
        const getBase64 = (file) => {
    return new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => {
            resolve(reader.result.split(",")[1]);
        };

        reader.onerror = (error) => {
            reject(error);
        };
    });
};

const handleAddDocument = async () => {

    if (!documentType || !documentFile) {
        toast.error("Please select document type and upload document.");
        return;
    }

    const allowedExtensions = profileDocTypes();

    const fileExtension = documentFile.name
        .split('.')
        .pop()
        .toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
        toast.error("Only PDF, PNG, JPG and JPEG files are allowed.");
        return;
    }

    const maxSize = profileDocSize();

    if (documentFile.size > maxSize) {
        toast.error("File size should not exceed 500 KB.");
        return;
    }

    const fileByte = await getBase64(documentFile);

    const params = JSON.stringify({
        customerId: parseInt(custID),
        documentType: documentType,
        documentName: documentFile.name,
        documentPath: "",
        createdBy: "admin",
        fileByte: fileByte,
        extenName: documentFile.name.substring(
            documentFile.name.lastIndexOf(".")
        )
    });

    axios.post(
        API_URL + "CustomerDocumentInsert",
        params,
        {
            headers: {
                "content-type": "application/json"
            }
        }
    )
    .then(function (response) {

        if (response.data.validStatus) {

            axios.get(
                API_URL +
                `GetCustomerDocumentsById/${custID}`
            ).then(docResponse => {

                setDocuments(docResponse.data);
            });

            toast.success(
                "Document Added Successfully"
            );

            setDocumentType('');
            setDocumentFile(null);

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
        else {
            toast.error(response.data.message);
        }
    })
    .catch(function (error) {

        console.log(error);

        toast.error(
            "Error while saving document."
        );
    });
};
        //Ended Nitesh on 12 09 2026

 //Upload profile Image code starts
	const changeProfileImage = () => 
  {

      if(newImageName!='')
      {
             const uploadImageparams = JSON.stringify({ 
			        "userProfilePictureId": 0,
			        "accountID": custID,
			        "fileName": userName,
			        "extenName": newImageExt,
			        "fileByte": newImageName    
            });

             //alert(API_URL +'UserProfilePic');
              axios.post(API_URL +'UserProfilePic', uploadImageparams, {
	            "headers": 
                {
                      "content-type": "application/json",    
                },
              })
              .then(function (response) 
              {
                  if(!response.data.validStatus)
                  {
                        toast.error(response.data.message);
                        console.log(response.data.message);
                       
                  }
                  else
                  {
                        //toast.success(response.data.message);
                        console.log(response.data.message);
                  }     
           
              })
      .catch(function (error) 
      {
            
            toast.error("Some Error occured while saving customer record, Please Provide valid Inputs");
            console.log(error);    
      });

      }
      else
      {

        alert("no image selected");
      }	  
      
	};
 //Upload profile Image code starts ends
 //Acknoledge alert update
const AlertAck=(MSGID)=>
{
 
    const daurls=API_URL+`ACKMessage/?AccountID=${user_id}&MSGID=${MSGID}&User=${login_name}`;  
   // alert(daurls);
     const response =  axios.get(daurls).then(response => 
    {   
      CountAlert();  
      showVehicleAlert(); 
      toast.success("Acknowledge successfully.");     

    }).catch(function(error) 
     {
          console.log(error.message);
    });     
 }       
 //Acknoledge alert update
const AllAlertAcknowlegement=(MSGID)=>
{
 
    const daurls=API_URL+`ACKMessage/?AccountID=${user_id}&MSGID=${MSGID}&User=${login_name}`;  
    const response =  axios.get(daurls).then(response => 
    {   
      CountAlert();  
      showVehicleAlert(); 
      toast.success("All Alerts Acknowledged successfully.");  
      closeModal();   

    }).catch(function(error) 
     {
          console.log(error.message);
    });     
 }       
   //Alert Process     TypeId 1 meanse unread message
const showVehicleAlert = () => 
   {
     setShowAlerts(true);
     const url=API_URL+`MessageList/?AccountID=${user_id}&TypeID=1`;  
     setVAlert([]);   
     axios.get(url).then(response => 
       {  
           console.log("Alert data");
           console.log(response.data.data);
           const data = response.data.data;
           setVAlert(data);  
          
       }).catch(function(error) 
       {
             console.log(error.message);       
       });     
   }
   //Count alert
const CountAlert = () => 
{
      const url=API_URL+`MessageList/?AccountID=${user_id}&TypeID=1`;  
     //alert(url);
     setAlertTotal(0);
      setVAlert([]);   
     axios.get(url).then(response => 
       {  
           console.log("Alert data");
           console.log(response.data.data);
           const data = response.data.data; 
           setVAlert(data);          
           //For Notification sound Start
           if(Object.keys(data).length>0)    
           {
             
                 setAlertCount(true);
                 console.log(alertCount);
                  const audio = new Audio("/tone/AvtNotification1.wav");
                  audio.play();                   
           }else{ setAlertCount(false);}
           //For Notification sound End
           setAlertTotal(Object.keys(data).length);         
            
       }).catch(function(error) 
       {
         
             console.log(alertCount);
             console.log(error.message);
       
       });
     
}
  // Component rendering logic
const showChangePasswordModal = () => 
{
       setShowCPModal(true); 
       setShowUpdateDetails(false);
}

const showUpdateProfileModal=()=>
{
        setShowUpdateDetails(true);
        setShowCPModal(false); 
        handleEdit(user_id)
}
   
// const closeUpdateCustomerModal=()=>
//    {
//         setShowUpdateDetails(false);
//         setShowCPModal(false); 
// }
//Added Nitesh On 12 09 2026
const closeUpdateCustomerModal=()=>
{
     setShowUpdateDetails(false);
     setShowCPModal(false);

     setDocuments([]);
     setDocumentType('');
     setDocumentFile(null);
}
//Added Nitesh on 12 09 2026
   
const closeChangePasswordModal = () => {
      setShowCPModal(false); 
      setShowUpdateDetails(false);
      setInputs([]);

}
const handleEdit=(index) => {
          
    const C_Id = index;                        
    const curls=API_URL+'countries';        
    axios.post(curls).then(response => {                            
    setCountryData(response.data.data)
     }).catch(function(error){console.log(error.message);});
        
     const surls=API_URL+`states?Country_ID=1`;
     axios.post(surls).then(response => {                            
      setStateData(response.data.data)
       }).catch(function(error){console.log(error.message);});

    const urls=API_URL+`GetGPSCustomerDetails/${C_Id}/`;
       
    axios.post(urls).then(response => 
    {
             
        setActionId('2'); 
        setCustID(response.data.data[0].accountID);  
        setCountryId(response.data.data[0].countryID); 
        setStateId(response.data.data[0].stateID);    
        setChangePass(true);    
        setCustType(response.data.data[0].customerTypeID); 
        setCustGST(response.data.data[0].gstNumber);  
        setRedioDispl(true);
        setProfileImage(Profile_Image_URL+response.data.data[0].profileImgFileName);
        
        //alert(response.data.data[0].customerTypeID);
        if(response.data.data[0].customerTypeID ==1)
        {
             //setCDisplay('block'); //for testing
              setCDisplay('none'); 
              setCNameLevel('Name');
  
        }
        else
        {
               setCDisplay('block');
               setCNameLevel('Company Name');
        }
        
             inputs.CustName=response.data.data[0].fullName;
             inputs.CustMobile= response.data.data[0].mobileNo;
             inputs.CustEmail= response.data.data[0].email;
             inputs.CustCompany= response.data.data[0].company;
             inputs.CustCity= response.data.data[0].city;
             inputs.CustPinCode= response.data.data[0].pinCode;
             inputs.CustUserName= response.data.data[0].userName;
             inputs.CustPassword= "Avaal@123";
             inputs.CustAddress= response.data.data[0].address; 
             inputs.CustCompanyWebsite= response.data.data[0].website;
             inputs.ContactPerson= response.data.data[0].contactName; 
             inputs.ContactNumber= response.data.data[0].contactPhone; 
             inputs.ContactEmail= response.data.data[0].contactEmail;    
             inputs.GSTNumber= response.data.data[0].gstNumber;        
             
             //Added Nitesh on 12 09 2026
             const customerId =
response.data.data[0].accountID;

axios.get(
API_URL +
`GetCustomerDocumentsById/${customerId}`
)
.then(docResponse => {

    setDocuments(docResponse.data);

})
.catch(error => {

    console.log(error);

});
             //Added Nitesh on 12 09 2026
                                                               
    }
    ).catch(function (error) {
       
      console.log(error.message);
          
   });   
          setShowUpdateDetails(true);
          setShowCPModal(false); 
                
}
const changeHandler = (event) => {
       
  const name = event.target.name;
  const value = event.target.value;
  setInputs(values => ({...values, [name]: value}))

}
const ChangeStateD = (e) => {

  setStateId(e.target.value);   

}
const ChangeCountryD = (e) => {

  setCountryId(e.target.value);
}
const setCustomerType=(event) =>
{
     if(event.target.value==1)
     {
           setCustType(1);           
           setCDisplay('none');  
           //setCDisplay('block'); //for testing

           setCNameLevel('Name');
     }
     else
     {
           setCustType(2);            
           setCDisplay('block');
           setCNameLevel('Company Name');
     }     
}
const changeProfilePassword=()=>
{
  if(inputs.currentPassword==='')
  {
        toast.error("Current password is required.");
        return;
  }
  else if(!inputs.currentPassword)
  {
       toast.error("Current password is required.");             
       return;
  }
  else if(inputs.newPassword==='')
  {
        toast.error("New password is required.");
        return;
  }
  else if(!inputs.newPassword)
  {
       toast.error("New password is required.");             
       return;
  }
  else if(inputs.confirmPassword==='')
  {
        toast.error("Confirm password is required.");
        return;
  }
  else if(!inputs.confirmPassword)
  {
       toast.error("Confirm password is required.");             
       return;
  }
  else if(inputs.newPassword != inputs.confirmPassword)
    {
         toast.error("Confirm password not match with new password.");             
         return;
    }
//Password validation starts
if (inputs.newPassword.length < 8) {
  toast.error('Invalid password, password must contain greater than or equal to 8 characters.')
  return
}

let countUpperCase = 0
let countLowerCase = 0
let countDigit = 0
let countSpecialCharacters = 0
let password = inputs.newPassword;
for (let i = 0; i < password.length; i++) {
  const specialChars = [
    '!', '@','#','$','%','^','&','*','(',')','_','-','+','=','[','{',']','}',':',';','<','>', ]

  if (specialChars.includes(password[i])) {
        countSpecialCharacters++
  } 
  else if (!isNaN(password[i] * 1)) {
        countDigit++
  } 
  else 
    {
    if (password[i] == password[i].toUpperCase()) 
      {
          countUpperCase++
    }
    if (password[i] == password[i].toLowerCase()) 
      {
         countLowerCase++
    }
  }
}

if (countLowerCase == 0) {
  toast.error('Invalid new password, no lower case characters in password')
  return
}

else if (countUpperCase == 0) {
  toast.error('Invalid new password, no upper case characters in password')
  return
}

else if (countDigit == 0) {
  toast.error('Invalid new password, no digit characters in password')
  return
}

else if (countSpecialCharacters == 0) {
  toast.error('Invalid new Password, no special characters in password')
  return
}
//Password validation ends
else
{
       const vparams = JSON.stringify({
        "Username": userName,
        "CurrentPassword": inputs.currentPassword,
        "NewPassword": inputs.newPassword,
        "ConfirmNewPassword": inputs.confirmPassword            
    });
   // alert(vparams);
    const curls = auTH_URL+'ChangePassword';
    //alert(curls);
    axios.post(curls, vparams, {

         "headers": 
         {
                "content-type": "application/json",    
         },

    })
      .then(function (response) 
      {
                             
        if(response.data.statusCode === 200 && !response.data.validStatus)
        {
            toast.error(response.data.message); 
        }
        else
        {
            setShowCPModal(false); 
            toast.success(response.data.message); 
                    
            //const root = ReactDOM.createRoot(document.getElementById('root'));
            //root.render(<AvtHome/>);                      
       }
      }).catch(function(error){console.log(error.message);});
  }
   //https://localhost:9082/Authorization/ChangePassword
}

const onClickRegister = () => {
  
   changeProfileImage();
    
  
  if(!inputs.CustName && custType===1)  
  {
    
    toast.error("Name is required.");
    return;
   }
  else if(inputs.CustName===''  && custType===1)
  {
    toast.error("Name is required.");
     return;
  }
  if(!inputs.CustName && custType===2)  
  {
     toast.error("Company name is required.");
     return;
   }
  else if(inputs.CustName===''  && custType===2)
  {
     toast.error("Company name is required.");
     return;
  }
  else if(!inputs.CustMobile)
  {
     toast.error("Customer mobile number is required.");
     return;
  }
  else if(inputs.CustMobile==='')
  {
     toast.error("Customer mobile number is required.");
     return;
  }
  else if(inputs.CustMobile.length<10 || inputs.CustMobile.length>10)
  {
     toast.error("Customer mobile number should be 10 digits.");
     return;
  }
  else if(!inputs.CustEmail)
  {
     toast.error("Customer email is required.");
     return;
  }
  else if(inputs.CustEmail==='')
  {
     toast.error("Customer email is required.");
     return;
  }
  else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputs.CustEmail))
  {
     toast.error("Customer email is invalid.");
     return;
  }  
  
  else if(!countryId)
  {
     toast.error("Country is required.");
     return;
  }
  else if(countryId==='')
  {
     toast.error("Country is required.");
     return;
  }
  else if(!stateId)
  {
     toast.error("State is required.");
     return;
  }
  else if(stateId==='')
  {
     toast.error("State is required.");
     return;
  }
  else if(!inputs.CustCity)
  {
     toast.error("City name is required.");
     return;
  }
  else if(inputs.CustCity==='')
  {
     toast.error("City name is required.");
     return;
  }
  else if(!inputs.CustPinCode)
  {
     toast.error("Pincode is required.");
       
     return;
  }
  else if(inputs.CustPinCode==='')
  {
     toast.error("Pincode is required.");
     return;
  }
  else if(!inputs.CustUserName)
  {
     toast.error("Username is required.");
     return;
  }
  else if(inputs.CustUserName==='')
  {
        toast.error("Username is required.");
        return;
  }
  else if(inputs.CustPassword==='')
  {
        toast.error("Password is required.");
        return;
  }
  else if(!inputs.CustPassword)
  {
       toast.error("Password is required.");             
       return;
  }
//Password validation starts
if (inputs.CustPassword.length < 8) {
  toast.error('Invalid password, password must contain greater than or equal to 8 characters.')
  return
}

let countUpperCase = 0
let countLowerCase = 0
let countDigit = 0
let countSpecialCharacters = 0
let password = inputs.CustPassword;
for (let i = 0; i < password.length; i++) {
  const specialChars = [
    '!', '@','#','$','%','^','&','*','(',')','_','-','+','=','[','{',']','}',':',';','<','>', ]

  if (specialChars.includes(password[i])) {
        countSpecialCharacters++
  } else if (!isNaN(password[i] * 1)) {
        countDigit++
  } else {
    if (password[i] == password[i].toUpperCase()) {
          countUpperCase++
    }
    if (password[i] == password[i].toLowerCase()) {
         countLowerCase++
    }
  }
}

if (countLowerCase == 0) {
  toast.error('Invalid password, no lower case characters in password')
  return
}

if (countUpperCase == 0) {
  toast.error('Invalid password, no upper case characters in password')
  return
}

if (countDigit == 0) {
  toast.error('Invalid password, no digit characters in password')
  return
}

if (countSpecialCharacters == 0) {
  toast.error('Invalid password, no special characters in password')
  return
}
//Password validation ends

 else  
{
 
     //Update Device Details
     const params = JSON.stringify({
                  
    "accountID": custID,
    "company": inputs.CustName,
    "gstNumber": inputs.GSTNumber, 
    "contactName": inputs.ContactPerson,
    "contactPhone": inputs.ContactNumber,
    "contactEmail": inputs.ContactEmail,
    "website": inputs.CustCompanyWebsite,
    "customerTypeID": custType,
    "fullName": inputs.CustName,
    "userName": inputs.CustUserName,
    "address": inputs.CustAddress,
    "city": inputs.CustCity,
    "pinCode": inputs.CustPinCode,
    "is_Active": 1,
    "countryID": countryId,
    "stateID": stateId,
    "mobileNo": inputs.CustMobile,
    "email": inputs.CustEmail,
    "createdBy": "admin"    
    });

     axios.post(API_URL +'GpsCustomersEdit', params, {

         "headers": 
         {
                "content-type": "application/json",    
         },

    })
      .then(function (response) 
      {
        if(!response.data.validStatus)
        {
                 toast.error(response.data.message);
                 //return;
        }
        else
        {
              
              toast.success(response.data.message);
              console.log(response.data);
        }     
           
      })
      .catch(function (error) 
      {
            
            toast.error("Some Error occured while saving customer record, Please Provide valid Inputs");
            console.log(error);    
      });
         
}

}

return (
    <>
	<header>
    <div className="container-fluid d-flex p-0">
    
      <div className="d-flex py-2 px-2"> 
        <a href="#" className="d-flex align-items-center me-3 text-decoration-none"> <img src= {avtlogo} alt="AVT LOGO" width="" height="" /> </a>
      
      </div>
      <div class="menu">
      
      <i class="fa-solid fa-bars fa-fw"></i>
      
      </div>

      <ul class="quicklinksTop" >
        <li class="quickLinkText" style={{ display: menuDisplay }}>

        <ul class="quicklinksList ml-5 tooltip-orange-peel" id="menu_ul" data-step="2" data-intro="Check your Quick Links for menu.">
              <li title="Dashboard">
              <a onClick={()=>GoToPage("/VehicleMonitor") }><i class="fa-sharp fa-light fa-grid-2" aria-hidden="true"></i></a></li>
              <li data-bs-toggle="tooltip" data-bs-placement="bottom" title="Devices"><a onClick={()=>GoToPage("/Devices") }><i class="fas fa-crutch" aria-hidden="true"></i></a></li>
              <li data-bs-toggle="tooltip" data-bs-placement="bottom" title="Vehicles"><a onClick={()=>GoToPage("/Vehicles") }>
                <i class="fas fa-truck" aria-hidden="true"></i></a>
                </li>
                <li  data-bs-toggle="tooltip" data-bs-placement="bottom" title="Drivers">
                         <a onClick={()=>GoToPage("/Drivers") }>
                         <i class="fas fa-user-tie" aria-hidden="true"></i></a></li>
                         <li data-bs-toggle="tooltip" data-bs-placement="bottom" title="Alerts">
                         <a onClick={()=>GoToPage("/Alert") }>
                         <i class="fas fa-bell" aria-hidden="true"></i></a></li>
                         <li data-bs-toggle="tooltip" data-bs-placement="bottom" title="Alert Settings">
                         <a onClick={()=>GoToPage("/AlertSettings") }>
                         <i class="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i></a></li>
                         <li data-bs-toggle="tooltip" data-bs-placement="bottom" title="History">
                         <a onClick={()=>GoToPage("/History") }>
                         <i class="fas fa-history" aria-hidden="true"></i></a></li></ul> </li>
      </ul>
      {/*start*/}
      <div class="d-flex align-items-center ms-auto">
        <ul class="navbar-nav flex-row flex-wrap ms-md-auto top-right-menu h-100">
         
          <li class="nav-item dropdown" style={{ display: menuDisplay }}> <a href="#"  class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"> <i class="fa-solid fa-bell"></i> Alert <span  class="count" id="NotificationCount">{alertTotal}</span> </a>
            <ul class="dropdown-menu notif-block">
            <div class="notif-heading"> Alert </div>
            <li style={{maxHeight:"350px",overflow:"auto" }}>
            <ul style={{padding: "0",listStyle: "none"}}>
            {
            vAlert.map(item=>
                    (
              <li>                
              <ul class="notif-body" >
               <li ><a href="#" class="dropdown-item"> <span class="text-primary"><i class="far fa-bell pr-5"></i>Received Time </span> <span class="media-annotation float-end">{item.receiveTime}</span>
               <div class="display-block text-muted mt-1">{item.smsContent}</div>
               </a></li>                
              </ul>
              </li>
            ))}
            </ul>
            </li>
            <div class="notif-footer"><a onClick={() =>showVehicleAlert()} href="#"> View All Reminders</a></div>
            </ul>
          </li>
          <li class="nav-item dropdown"> <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"> <i class="fa-solid fa-circle-question"></i> <span> Help</span> </a>
          <ul class="dropdown-menu dropdown-menu-end">
              <li> <a class="dropdown-item" href="mailto:support@avaalavt.com" target="_blank"><i class="fa-thin fa-envelope"></i> Email Support</a></li>              
              <li><a class="dropdown-item" href="tel:0124 436 6313"><i class="fa-thin fa-phone"></i> (91) 0124 436 6313</a></li>
              <li><a class="dropdown-item" onClick={()=>GoToPage("/UserHelp") }> <i class="fa fa-book"></i> User Manual </a> </li>
          </ul>
          </li>
          <li  class="nav-item"> <a href="#" onClick={handleLogout}> <i class="fa-solid fa-right-from-bracket"></i> <span>SignOut</span> </a></li>
          <li class="dropdown"> <a href="#" class="dropdown-toggle account" data-bs-toggle="dropdown" aria-expanded="false"> <span class="account-pic"> 
          <img src={profileImage}  alt="mdo" width="36" height="50" class="rounded-circle"/> </span> 
          <span class="account-name">{login_name}</span> </a>
          <ul class="dropdown-menu text-small shadow">
          <li class="dropdown-item">
          <ul class="notification-heading-list">
                <li> Logged in: <strong className="text-uppercase" id="spanUserName">{user_name}</strong> (<span className="normal-white-space" id="spanUserRoles">{user_role}</span>) </li>
                <li> User Type: <span id="corporateID">{user_role}</span> </li>  
                <li> <i class="fa-light fa-envelope"></i> <span id="emailID">support@avaalavt.com</span> </li>
                <li> <i class="fa-thin fa-phone"></i> <a href="tel:6479431320">(91) 0124 436 6313</a> </li>
          </ul>
          </li>
          <li style={{ display: menuDisplay }} ><a href="#" onClick={showUpdateProfileModal} className="dropdown-item">Update Profile</a></li>
          {/* <li style={{ display: menuDisplay }} ><a href="#" onClick={showProfileImageModal} className="dropdown-item">Update Profile Image</a></li> */}
          <li><a href="#" onClick={showChangePasswordModal} className="dropdown-item">Change Password</a></li>               
          </ul>
          </li>
        </ul>
      </div>
      {/*end*/}
      {/*
      <div className="d-flex align-items-center ms-auto">    
      <a id="NotificationsLink"  aria-haspopup="true" aria-expanded="false">
                <i style={{cursor:"pointer"}} onClick={() =>showVehicleAlert()} class="fas fa-bell"></i>{alertTotal}
                <span onClick={() =>showVehicleAlert()} class="label" id="spnNotificationCount"></span>
            </a>

        <ul className="navbar-nav flex-row flex-wrap ms-md-auto top-right-menu h-100">
        
          <li className="dropdown"> <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"> <span className="account-pic"> 
          <img src={avtprofile}  alt="mdo" width="32" height="32" className="rounded-circle"/> </span> <span className="account-name">{login_name}</span> </a>
            <ul className="dropdown-menu text-small shadow">
              <li className="dropdown-item">
                <ul className="notification-heading-list">
                  <li> Logged in: <strong className="text-uppercase" id="spanUserName">{user_name}</strong> (<span className="normal-white-space" id="spanUserRoles">{user_role}</span>) </li>
                  <li> User Type: <span id="corporateID">{user_role}</span> </li>                 
                </ul>
              </li>
              <li style={{ display: menuDisplay }} ><a href="#" onClick={showUpdateProfileModal} className="dropdown-item">Update Profile</a></li>
              <li><a href="#" onClick={showChangePasswordModal} className="dropdown-item">Change Password</a></li>
              <li><a href="#" className="dropdown-item" onClick={handleLogout}>Logout</a></li>               
            </ul>
          </li>
        </ul>
      </div>*/}
    </div>

  </header>


<Modal isOpen={showCPModal} >
  
<div class="modal-header justify-content-center bg-white border-0">
            
                <h5 className='modal-title'>Change Password</h5>
                <button type="button" class="btn-close" onClick={closeChangePasswordModal}></button>
 </div>
  <div class="modal-body">
                          <div className='row'>
                          <div className="form-group"> 
                          Current Password <span style={{color:"red"}}>&nbsp;*</span>
                          <input name="currentPassword"  type="password" maxLength={50}  className="form-control"  value={inputs.currentPassword || ""}  onChange={changeHandler}/>
                          </div>
                          <div className="form-group"> 
                          New Password <span style={{color:"red"}}>&nbsp;*</span>
                          <input name="newPassword"  type="password"  maxLength={50} className="form-control"  value={inputs.newPassword || ""}  onChange={changeHandler}/>
                          </div> 
                          <div className="form-group"> 
                          Confirm Password <span style={{color:"red"}}>&nbsp;*</span>
                          <input name="confirmPassword"  type="password"  maxLength={10}  className="form-control"  value={inputs.confirmPassword || ""}  onChange={changeHandler}/>
                          </div>                                                      
                          </div>
                          <div class="justify-content-center">
                          <button className="btn btn-primary2" onClick={() => changeProfilePassword()}>Change</button>   
                        </div>          
            
   </div>
                  
</Modal>

<Modalxl isOpen={showUpdateDetails} style={{ "z-index": 25}}>  
 <div class="modal-header">
 <h5 className='modal-title'>Update Profile</h5>
 <button type="button" id="closeAddCustomerModal" class="btn-close" onClick={closeUpdateCustomerModal}></button>
 </div>
 <div class="modal-body">          
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px", display: cDisplay }}><b>Company Details </b> </span>                      
<div class="row">
<div class="col-sm-4 col-md-4 form-group" >     
<div class="col-sm-12 form-group">{cNameLevel}:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustName"  type="text" required="required"  className="form-control"  value={inputs.CustName} onChange={changeHandler} ></input></div>
<div class="col-sm-12 form-group">Email:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustEmail" type="text" required="required" className="form-control" disabled={true} value={inputs.CustEmail} onChange={changeHandler} ></input></div>
<div class="col-sm-12 form-group">
Country:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control" name="DCountry" value={countryId} onChange={ChangeCountryD}>
<option>Select Country</option>
{countryData.map((e, key) => {
   return <option key={key} value={e.id}>{e.country_Name}</option>;
 })}
</select>
</div>    
<div class="col-sm-12 form-group">
Address:
<textarea name="CustAddress" type="text" className="form-control" value={inputs.CustAddress} onChange={changeHandler} rows={2} cols={20} />
</div> 
   
</div>
<div class="col-sm-4 col-md-4 form-group" >
<div class="col-sm-12 form-group">
Mobile Number:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustMobile" type="text" required="required" className="form-control" maxLength={10} value={inputs.CustMobile} onChange={changeHandler} ></input>
</div>
<div class="col-sm-12"><br/><br/><br/></div>
<div class="col-sm-12 form-group">
State:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control slct" name="DState" value={stateId} onChange={ChangeStateD}>
<option>Select State</option>
{stateData.map((e, key) => {
return <option key={key} value={e.id}>{e.state_Name}</option>;
})}
</select>
</div>    
<div class="col-sm-12 form-group">
PinCode:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustPinCode"  type="text" required="required"  maxLength={6} className="form-control" value={inputs.CustPinCode} onChange={changeHandler} ></input>
</div>   
<div class="col-sm-12 form-group" style={{display: cDisplay }}>
Website:
<input name="CustCompanyWebsite" type="text" required="required" className="form-control" value={inputs.CustCompanyWebsite} onChange={changeHandler} ></input>
</div> 
</div>
<div class="col-sm-4 col-md-4 form-group" >
<div class="col-sm-12 form-group" style={{textAlign:'center'}}>
<br/>
<center style={{ border: "1px solid #cbcbcb", borderRadius: "5px", display: "inline-block", margin: "auto", padding: "7px", outline:"2px solid #e1e1e1;", outlineOffset:"-3px", }}>
<img src={profileImage} alt="Profile Image" width="100" height="120" style={{filter: "invert(0)"}}/> 
</center>
<br/><br/>
<div style={{float:'right' }}>      
<input type="file" name="" id="fileId" onChange={imageUploaded}></input>    
</div></div>
<br/>
<div class="col-sm-12 form-group">
City:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustCity"  type="text" required="required"  className="form-control"  value={inputs.CustCity} onChange={changeHandler} ></input>
</div>
<div class="col-sm-12 form-group" style={{display: cDisplay}}>
GST Number:      
<input name="GSTNumber"  type="text" required="required"  className="form-control"  value={inputs.GSTNumber} onChange={changeHandler} ></input>
</div> 
</div>
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px", display: cDisplay }}><b>Contact Details </b> </span> 
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Person:
<input name="ContactPerson" type="text" required="required" className="form-control" value={inputs.ContactPerson} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Number:
<input name="ContactNumber" type="text" required="required" maxLength={10} className="form-control" value={inputs.ContactNumber} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Email:
<input name="ContactEmail" type="text" required="required" className="form-control" value={inputs.ContactEmail} onChange={changeHandler} ></input>
</div>

{/*
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>User/Login Details </b> </span> 
<div class="col-sm-4 col-md-4 form-group">
User/Login Name:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustUserName"  type="text" required="required"  className="form-control" placeholder='User/Login Name Used for login' disabled={changePass} value={inputs.CustUserName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Password:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustPassword"  type="password" required="required" placeholder='Min 8 characters, at least 1 uppercase letter, 1 lowercase letter and 1 number' disabled={changePass}  className="form-control" value={inputs.CustPassword} onChange={changeHandler} ></input>
</div>		


<script>
$('document').ready(function(){
            $('.menu').click(function()
            {
            $('body').toggleClass('close')
            })
        })
</script>*/}
{/* <div class="col-sm-12 col-md-12 form-group">
<center>
<button type="submit" id="Save" onClick={onClickRegister} className="btn btn-primary2">Update </button>
    
</center>
</div> */}
{/* Added Nitesh on 12 06 2026 */}
<div class="col-sm-12 col-md-12 form-group">
<center>
<button
type="submit"
id="Save"
onClick={onClickRegister}
className="btn btn-primary2">
Update
</button>
</center>
</div>

<br/>

<span
style={{
borderBottom: "1px solid #dadada",
padding: "5px",
marginBottom:"10px",
fontSize:"14px"
}}>
<b>Documents Details</b>
</span>

<div className="row">

    <div className="col-md-4 form-group">
        <label>
            Document Type
            <span style={{ color: "red" }}>
                *
            </span>
        </label>

        <select
            className="form-control"
            value={documentType}
            onChange={(e) =>
                setDocumentType(e.target.value)
            }>
            <option value="">
                Select Document Type
            </option>

            <option value="Aadhar">
                Aadhar Card
            </option>

            <option value="DL">
                Driving License
            </option>

            <option value="RC">
                RC
            </option>
        </select>
    </div>

    <div className="col-md-4 form-group">
        <label>
            Upload Document
            <span style={{ color: "red" }}>
                *
            </span>
        </label>

        <input
            type="file"
            className="form-control"
            ref={fileInputRef}
            accept=".pdf,.png,.jpg,.jpeg"
            onChange={(e) =>
                setDocumentFile(
                    e.target.files[0]
                )
            }
        />
    </div>

    <div className="col-md-4 form-group">

        <label>&nbsp;</label>

        <br/>

        <button
            type="button"
            className="btn btn-primary"
            onClick={handleAddDocument}>
            Add Document
        </button>

    </div>

</div>

{documents.length > 0 && (

<div className="col-sm-12 col-md-12 form-group">

<table className="table table-bordered">

<thead>

<tr>
<th>Document Type</th>
<th>Document</th>
<th>Action</th>
</tr>

</thead>

<tbody>

{documents.map((item,index) => (

<tr key={index}>

<td>{item.documentType}</td>

<td>{item.documentName}</td>

<td>

<button
type="button"
className="btn btn-info btn-sm me-2"
onClick={() => {
window.open(
API_URL +
`ViewCustomerDocument/${custID}/${item.documentName}`,
"_blank"
);
}}>
View
</button>

&nbsp;

<button
type="button"
className="btn btn-danger btn-sm"
onClick={() => {

const documentId =
item.documentID;

if (!documentId){
toast.error(
"Document ID not found."
);
return;
}

axios.post(
API_URL +
`DeleteCustomerDocument/${documentId}`
)
.then((response) =>{
  if (response.data.validStatus)
     {console.log(response.data.validStatus);toast.success("Document Deleted Successfully"
);

axios.get(
API_URL +
`GetCustomerDocumentsById/${custID}`
)
.then((docResponse) => {

setDocuments(
docResponse.data
);

});

}
else {
toast.error(response.data.message);
}

})
.catch((error) => {
console.error(error);
if (error.response) {
toast.error(error.response.data?.message || "Server error occurred");
} else {toast.error("Unable to connect to server");}
});

}}>
Delete
</button>

</td>

</tr>

))}

</tbody>

</table>

</div>

)}
{/* Ended Nitesh on 12 09 2026 */}


</div></div>
</Modalxl>
    {/* Alert Popup*/}
  <ModalAlert style={{ zIndex:"20"}} isOpen={showAlerts} >
     <div class="modal-header">
                <h5 className='modal-title'>Alert Details</h5>             
                <button type="button" class="btn-close" onClick={closeModal}></button>
                </div>
                 
                <div class="modal-body" >
                  <div  class="row flex-column">                  
                 <div>  {alertCount ? (<button  onClick={() => AllAlertAcknowlegement(0)} style={{ float:'right'}} class="btn btn-secondary">Clear All</button>) : ''}</div>
                 <div className='py-3' style={{ "height": "550px", "overflow-y": "auto"}}>
                {vAlert.map(item=>
                    (
                      <div class="shadow px-4 py-3 rounded-2 mb-3">
                      
                        <div class="row">
                          
                          <div class="col-8">     
                            <div className='row'>
                              <div className='col-12'>

                          <i class={item.status==="Online"?"fa-duotone fa-square text-success":"fa-duotone fa-square  text-danger"}></i>  
                          {item.vehicleNumber} &nbsp; &nbsp; &nbsp; &nbsp;<a href="#" className='text-info' title={item.smsContent}> {item.alertType}</a> 
                          </div>
                          
                          

                              
                              <div class="col-12 mb-1"> 
                              <strong>Priority:&nbsp; </strong>
                              <span class={item.priorities==="Critical"?"text-danger":(item.priorities==="Low"?"text-success":"text-warning")}>{item.priorities}</span>                               
                              </div>
                              <div class="col-12 mb-1"><strong>Received Time</strong> - {item.receiveTime} </div> 
                              <div class="col-12 mb-1"><strong>Message</strong>-{item.smsContent}</div> 
                                          
                             </div>
                              </div>                            
                             <div class="col-4 text-end">
                              <button  onClick={() => AlertAck(`${item.msgid}`)} class="btn btn-primary2">Acknowledge</button>
                              </div>
                              
                            </div>
                            </div>
                          
                          ))
                          }
                      
                          <div style={{textAlign:"center"}} hidden={alertCount}><h3>No Data Found</h3></div>
     

                          </div>
                 </div>
                
                </div>
        </ModalAlert>
        {/*End of popup*/}
<ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
</>
);  
};

export default AdminMaster;